// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-bwMKM","avatarCharityName":"jgp-bFD4M","textContent":"jgp-3WSDw"};